
























import Vue from 'vue';

type DataType = {
  menuVisible: boolean;
};

export default Vue.extend({
  name: 'buyer-index',
  data(): DataType {
    return {
      menuVisible: false,
    };
  },
  computed: {
    mainLinks() {
      if (this.$auth.isAnonymous) {
        return [
          { text: 'お気に入りリスト', to: '/buyer/favorites', icon: 'checklist' },
        ];
      } else {
        return [
          { text: 'お気に入りリスト', to: '/buyer/favorites', icon: 'checklist' },
          { text: '予約展示会', to: '/buyer/vis', icon: 'vis' },
          { text: 'お問い合わせ一覧', to: '/buyer/contact', icon: 'contact' },
        ];
      }
    },
    accountLinks() {
      if (this.$auth.isAnonymous) {
        return [];
      } else {
        return [
          {
            text: '担当者情報',
            to: '/buyer/setting/userinfo',
            icon: 'charger-info',
          },
          {
            text: '企業情報',
            to: '/buyer/setting/company',
            icon: 'company-info',
          },
          {
            text: 'アカウント情報',
            to: '/buyer/setting/account',
            icon: 'account-info',
          },
        ];
      }
    },
  },
  methods: {
    onMenu() {
      this.menuVisible = !this.menuVisible;
    },
  },
});
